import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { LineItemMonitorDataService } from "../line-item-monitor-data.service";
import { LineItemLinksResponse } from "../line-item-monitor.model";

@Component({
  selector: "app-line-item-links",
  templateUrl: "./line-item-links.component.html",
  styleUrls: ["./line-item-links.component.scss"],
})
export class LineItemLinksComponent implements OnInit {
  @Input() ticker: string;
  @Input() dapParameterId: string;
  @Output() onLinkClick = new EventEmitter();
  loading = true;
  linksObj: Array<any> = [];

  constructor(private dataService: LineItemMonitorDataService) {}

  ngOnInit(): void {
    this.loading = true;
    this.dataService
      .getLineItemLinks(this.ticker, this.dapParameterId)
      .subscribe((response: LineItemLinksResponse) => {
        this.loading = false;
        const { sch_links: schLinksT, nmv_links: nmvLinksT } = response;
        const nmvLinks = [];
        Object.keys(nmvLinksT).forEach((key) => {
          const obj = nmvLinksT[key];
          Object.keys(obj).forEach((linkKey) => {
            const linkObj = obj[linkKey];
            const linkText = `[${linkObj.tab_name}] ${linkObj.line_name}`;
            const hyperlink = `/mex/${this.ticker}/NMV/${linkObj.tab_shortname}?dpid=${linkObj.line_id}`;
            nmvLinks.push({
              linkText,
              hyperlink,
            });
          });
        });
        this.linksObj.push({
          header: "Company",
          links: nmvLinks,
        });

        Object.keys(schLinksT).forEach((key) => {
          Object.keys(schLinksT[key]).forEach((head) => {
            const group = schLinksT[key][head];
            const header = group.header;
            const schLinks = {
              header,
              links: [],
            };
            Object.keys(group.links).forEach((link) => {
              const linkObj = group.links[link];
              const linkText = `[${linkObj.tab_name}] ${linkObj.line_name}`;
              const hyperlink = `/mex/${this.ticker}/SCH/${linkObj.tab_shortname}?dpid=${linkObj.line_id}`;
              schLinks.links.push({
                linkText,
                hyperlink,
              });
            });
            this.linksObj.push(schLinks);
          });
        });
      });
  }
  linkClick() {
    this.onLinkClick.emit();
  }
}
